export default __webpack_public_path__ + "static/media/bruce-mars.45f64779.jpg";